module.exports = __webpack_public_path__ + "img/gPay-WhatApp.9122bb5b.svg";